export default "__VITE_ASSET__$18F9GT3__"